export const FIELD_REQUIRED = "field.required";
export const TELEPHONE_INVALIDE = "field.telephone";
export const EMAIL_INVALIDE = "field.email";
export const UNSUPPORTED_FILE_FORMAT = "field.unsupportedFileFormat";
export const MAX_FILE_SIZE = "field.maxFileSize";
export const FIELD_NUMBER = "Ce champ doit être un nombre.";
export const FIELD_STRING = 'Ce champ doit être de type "String".';
export const MDP_MUST_MATCH = 'mdp.must.match';
export const MDP_CHARACTERS = 'mdp.characters';
export const MDP_MIN = 'mdp.min';
export const MDP_MAX = 'mdp.max';

